<div class="col-12 company-agent-report">
<div class="card mb-3">
<div class="card-header d-flex flex-row justify-content-between">        
    <h2 class="card-title mb-0">Company Agent Report</h2>
</div>
<div class="card-body">
<div class="d-flex flex-column flex-md-row gap-3 align-items-md-end mb-3">
    <div class="company-agent-report-filter">
        <label for="from" class="form-label">From</label>
        <input id="from" type="date" class="form-control" [max]="today" [(ngModel)]="data.from" />
    </div>
    <div class="company-agent-report-filter">
        <label for="to" class="form-label">To</label>
        <input id="to" type="date" class="form-control" [max]="today" [(ngModel)]="data.to" />
    </div>
    <button class="btn btn-primary" (click)="filter()">Filter</button>
</div>
</div>
</div>
<div class="card" *ngIf="!is_loading_logs">
    <div class="card-body">
        <h4 class="fw-bolder border-bottom pb-2">Report Date: </h4>
        <div class="table-responsive company-agent-report-scroll">
        <table class="table table-bordered company-agent-report-table">
            <thead class="table-dark">
                <tr>
                    <th>Game</th>
                    <th class="text-end">Total Bet</th>
                    <th class="text-end">Total Wins</th>
                    <th class="text-end">Player</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let log of logs" class="game-row" (click)="openGameDetail(log)" title="Click to view per-player winloss for this game">
                    <td>
                        <a class="game-link">{{log.game_title}}{{log.platform ? ' (' + log.platform + (log.platform_type ? ' - ' + log.platform_type : '') + ')' : ''}}</a>
                    </td>
                    <td class="text-end">{{log.bet | number:'1.2-2'}}</td>
                    <td class="text-end">{{log.winloss | number:'1.2-2'}}</td>
                    <td class="text-end">{{log.player * -1 | number:'1.2-2'}}</td>
                </tr>
                <tr *ngIf="logs.length === 0">
                    <td colspan="4" class="text-center">No data found</td>
                </tr>
            </tbody>
            <tfoot class="table-dark" *ngIf="logs.length > 0">
                <tr>
                    <td>Total</td>
                    <td class="text-end">{{sum('bet') | number:'1.2-2'}}</td>
                    <td class="text-end">{{sum('winloss') | number:'1.2-2'}}</td>
                    <td class="text-end fw-bolder">{{sum('player') * -1 | number:'1.2-2'}}</td>
                </tr>
            </tfoot>
        </table>
        </div>
    </div>
</div>
</div>
